import trackMiddleware from "@/router/middleware/trackMiddleware";
import { loadAccessToken, removeAccessToken } from "@/utils/storage";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default [
  async ({ to }: MiddlewareInterface) => {
    const accessToken = loadAccessToken();

    if (!accessToken) {
      return;
    }

    removeAccessToken();

    const restrictedHosts = import.meta.env.VITE_RESTRICTED_MEMBERAREA_HOSTS.split(",");
    const host = window.location.host.split(".").slice(-2).join(".");

    if (restrictedHosts.includes(host)) {
      await new Promise(() => {
        window.location.href = `${import.meta.env.VITE_MEMBERAREA_HOST + to.fullPath}?authToken=${accessToken}`;
      });
    }
  },
  trackMiddleware,
];
